import { gsap, ScrollTrigger } from "@gsap";

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".image_text_cards-layout").forEach((layout) => {
		const cards = gsap.utils.toArray("a.image-text-card", layout);
		if (!cards.length) return;

		gsap.matchMedia().add("(hover: none)", () => {
			const triggers = cards.map((card) =>
				ScrollTrigger.create({
					trigger: card,
					start: "top 60%",
					toggleClass: { targets: card, className: "is-active" },
					end: "max",
				}),
			);

			return () => triggers.forEach((trigger) => trigger.kill());
		});
	});
});
